import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;
  fill?: string;

  [prop: string]: unknown;
}

export default ({ style, fill = '#0F2F4C', ...rest }: IProps) => {
  const defaultStyle = { width: 155, height: 30 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height}
         viewBox="0 0 155 30" fill="none" {...rest}>
      <path
        d="M75 13C75 15.5773 74.2936 17.9794 73 20H67.9955C69.942 18.35 71 15.8273 71 13C71 8.02944 66.9706 4 62 4C57.0294 4 53 8.02944 53 13C53 15.8273 54.0535 18.35 56 20H51C49.7064 17.9794 49 15.5773 49 13C49 5.8203 54.8203 0 62 0C69.1797 0 75 5.8203 75 13Z"
        fill={fill} />
      <path d="M0 1V23H4V6L12.5 23H14.5L23 6V23H27V1H21L13.5 16L6 1H0Z" fill={fill} />
      <path
        d="M89.5704 18C88.663 18.9257 87.3987 19.5 86 19.5C83.2386 19.5 81 17.2614 81 14.5C81 11.7386 83.2386 9.5 86 9.5C87.3987 9.5 88.663 10.0743 89.5704 11H94C92.6334 7.76806 89.7292 5.5 86 5.5C81.0294 5.5 77 9.52944 77 14.5C77 19.4706 81.0294 23.5 86 23.5C89.7292 23.5 92.6334 21.2319 94 18H89.5704Z"
        fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M105 19.5C106.126 19.5 107.165 19.1279 108 18.5H113C111.527 21.4634 108.534 23.5 105 23.5C100.029 23.5 96 19.4706 96 14.5C96 9.52944 100.029 5.5 105 5.5C109.971 5.5 114 9.52944 114 14.5V16.5H100.416C101.188 18.2659 102.95 19.5 105 19.5ZM105 9.5C102.761 9.5 100.866 10.9714 100.229 13H109.771C109.134 10.9714 107.239 9.5 105 9.5Z"
            fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M130 7.01555C128.57 6.05827 126.85 5.5 125 5.5C120.029 5.5 116 9.52944 116 14.5C116 19.4706 120.029 23.5 125 23.5C126.85 23.5 128.57 22.9417 130 21.9845V23H134V6H130V7.01555ZM130 14.5C130 17.2614 127.761 19.5 125 19.5C122.239 19.5 120 17.2614 120 14.5C120 11.7386 122.239 9.5 125 9.5C127.761 9.5 130 11.7386 130 14.5Z"
            fill={fill} />
      <path
        d="M154.062 10.5C154.673 11.7318 155 13.0991 155 14.5V23H151V14.5C151 11.7386 148.761 9.5 146 9.5C143.239 9.5 141 11.75 141 14V23H137V6H141V7.01664C142.469 6.03502 144.207 5.5 146 5.5C148.387 5.5 150.676 6.44821 152.364 8.13604C153.061 8.83325 153.632 9.63307 154.062 10.5Z"
        fill={fill} />
      <path d="M29 6L36.2639 20.5L31.5 30H36L48 6H43.5L38.5 16.0279L33.5 6H29Z" fill={fill} />
    </svg>
  );
};
